import React from 'react'
import "./FormContainer.css"
import { Col, Container, Row } from 'react-bootstrap'
import CustomInput from '../CustomInput/CustomInput'
import CustomButton from '../CustomButton/CustomButton'
import Select from 'react-select';
import { FaFilePdf } from "react-icons/fa";
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { fetchProducts } from '../../hooks/Products'
import { toast } from 'react-toastify'
import { apiUrl } from '../../constants/apiUrl'

function FormContainer({ inputs, btnText, content, handleSubmit, loading, imagePreview, pdfPreviewUrl }) {
  const userinfo = useSelector((state) => state);
  const dispatch = useDispatch()
  return (
    <div className='form_container'>
      <Container fluid>
        <Row>
          {inputs.map((item) => {
            return (
              <Col md={item?.grid} key={item?.id} className='mb-3'>
                <label className='label'>{item?.name}</label>{
                  item?.type == "select" ?

                    <Select
                      value={item?.value}
                      onChange={item?.onChanegFunction}
                      options={item?.options}
                      placeholder={item?.name}
                      className='input_select mt-2'
                      isMulti={item?.isMulti}
                      search={item?.search}


                    />
                    :
                    <CustomInput
                      placeholder={item?.name}
                      handleChange={item?.onChanegFunction}
                      name={item?.name}
                      value={item?.value}
                      type={item?.type ? item?.type : "text"}
                      accept={item?.accept}
                      multiple={item?.multiple}


                    />

                }

              </Col>
            )
          })}

        </Row>
        <Row>
          <Row className="mt-3">
            {imagePreview && (
              Array.isArray(imagePreview) ? (
                <div className="d-flex flex-wrap gap-2">
                  {imagePreview.map((src, index) => (
                    <div key={index} className="position-relative">
                      <button className='position-absolute rounded border' style={{
                        backgroundColor: "red",
                        color: "#ffff"
                      }}
                        onClick={async () => {
                          if(src?.image){
                          await axios
                            .delete(`${apiUrl}/admin/products/images/${src?.id}`,

                              {
                                headers: {
                                  Authorization: `Bearer ${userinfo?.auth.userArray.access_token}`
                                }
                              })

                            .then(async (res) => {
                              window.location.reload();
                              toast.success("image Delete successfully", {
                                position: "bottom-right",
                                autoClose: 3000,
                              });
                            })
                            .catch((error) => {



                            });
                          }
                        }}
                      >x</button>
                      <img
                        src={src?.image ? src?.image : src}
                        alt={`preview-${index}`}
                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: "8px", border: "1px solid #ddd" }}
                        onError={(e) => { e.target.style.display = 'none'; }} // إخفاء الصورة إذا فشل التحميل بدلاً من إظهار نص alt
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center">
                  <img
                    src={imagePreview}
                    alt="single-preview"
                    style={{ width: "200px", borderRadius: "10px", border: "1px solid #ddd" }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </div>
              )
            )}
          </Row>
        </Row>
        <Row>
          <Col md={6}>
            {pdfPreviewUrl &&
              <FaFilePdf
                size={40}
                color="red"
                style={{ cursor: "pointer" }}
                onClick={() => window.open(pdfPreviewUrl, "_blank")}
              />
            }
          </Col>
        </Row>
        {content &&
          <Row>
            {content}
          </Row>
        }
        <Row>
          <div className='w-50 text-center m-auto mt-4'>
            <CustomButton
              disable={loading}
              onPress={handleSubmit}
              text={btnText}

            />
          </div>
        </Row>

      </Container>
    </div>
  )
}

export default FormContainer
